module.exports = __webpack_public_path__ + "assets/media/lunch.6909cdd9.mp3";